<template>
  <div class="accordion">
    <div
      class="accordion-header inline-block"
      @click="isOpen = !isOpen"
    >
      <h3 class="text-primary pr-4 underline my-2 font-poppins-bold">
        {{ title }}
      </h3>
      <span
        class="arrow"
        :class="{ open: isOpen }"
      >▼</span>
    </div>
    <div
      class="accordion-body"
      :class="{ open: isOpen }"
    >
      <div class="accordion-content text-grey-darkest">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Click to expand'
    }
  },
  data () {
    return {
      isOpen: false
    };
  }
};
</script>

<style scoped>
.accordion-header {
  padding: 6px 0;
  cursor: pointer;
  display: flex;
  justify-content: start;
  align-items: center;
  user-select: none;
}

.accordion-header:hover {
  background: #eee;
}

.arrow {
  transition: transform 0.3s ease;
  font-size: 12px;
}

.arrow.open {
  transform: rotate(180deg);
}

.accordion-body {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
  text-align: left;
}

.accordion-body.open {
  grid-template-rows: 1fr;
}

.accordion-content {
  overflow: hidden;
}
</style>
